import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app/app';
import {unregister} from './register-service-worker';
// import OneDaciaHeader from '@makolab/library-react/dist/OneDaciaHeader';
// import OneRenaultHeader from '@makolab/library-react/dist/OneRenaultHeader';
// import OneFooter from '@makolab/library-react/dist/OneFooter';
// import console from '@makolab/library-react/dist/console';
// import JssProvider from 'react-jss/lib/JssProvider';
// import {MuiThemeProvider} from '@material-ui/core/styles';

// import {jss, generateClassName} from './styles/jss-config';
// import theme from './styles/theme-header-footer';

// import headerJsonRenault from './header-json.renault.json';
// import headerJsonDacia from './header-json.dacia.json';
// import footerJsonRenault from './footer-json.renault.json';
// import footerJsonDacia from './footer-json.dacia.json';

// const isFrontendPreview =
//   (process.env.NODE_ENV === 'production') &&
//   (window.location.hostname === 'rancher.makolab.net');

// header renderer
// we split rendering into two try catch blocks to not stop rendering second element when first one throws
// (() => {
//   if (window.location.pathname.endsWith('/dealer-form') ||
//     window.location.pathname.endsWith('/dealer-form/thank-you') ||
//     window.location.pathname.endsWith('/confirm')
//   ) {
//     return;
//   }
//   const headerEl = document.getElementById('mlb-one-header');

//   if (!headerEl) {
//     console.warn('Header #mlb-one-header element not found, skipping');
//     return;
//   }

//   try {
//     const headerJson = document.getElementById('mlb-one-header-config').innerHTML;
//     let headerData = JSON.parse(headerJson);
//     if (
//       (process.env.NODE_ENV !== 'production') || // on development
//         isFrontendPreview // or frontend preview page
//     ) {
//       headerData = process.env.REACT_APP_BRAND === 'Renault' ? headerJsonRenault : headerJsonDacia;
//     }

//     ReactDOM.render((
//       <JssProvider
//         jss={jss}
//         generateClassName={generateClassName}
//       >
//         <MuiThemeProvider theme={theme}>
//           {process.env.REACT_APP_BRAND === 'Renault' ? (
//             <OneRenaultHeader headerZone={headerData}/>
//           ) :
//             (
//               <OneDaciaHeader headerZone={headerData}/>
//             )}
//         </MuiThemeProvider>
//       </JssProvider>
//     ), headerEl);
//   } catch (e) {
//     console.error(e);
//   }
// })();

ReactDOM.render(<App />, document.getElementById('root'));

// footer renderer
// (() => {
//   if (window.location.pathname.endsWith('/dealer-form') ||
//     window.location.pathname.endsWith('/dealer-form/thank-you') ||
//     window.location.pathname.endsWith('/confirm')
//   ) {
//     return;
//   }
//   const footerEl = document.getElementById('mlb-one-footer');

//   if (!footerEl) {
//     console.warn('Footer #mlb-one-footer element not found, skipping');
//     return;
//   }

//   try {
//     const footerJson = document.getElementById('mlb-one-footer-config').innerHTML;
//     let footerData = JSON.parse(footerJson);
//     if (
//       (process.env.NODE_ENV !== 'production') || // on development
//         isFrontendPreview // or frontend preview page
//     ) {
//       footerData = process.env.REACT_APP_BRAND === 'Renault' ? footerJsonRenault : footerJsonDacia;
//     }

//     ReactDOM.render((
//       <JssProvider
//         jss={jss}
//         generateClassName={generateClassName}
//       >
//         <MuiThemeProvider theme={theme}>
//           <OneFooter footerZone={footerData}/>
//         </MuiThemeProvider>
//       </JssProvider>
//     ), footerEl);
//   } catch (e) {
//     console.error(e);
//   }
// })();

unregister();



// WEBPACK FOOTER //
// ./src/index.js